import { useSelector, useDispatch } from 'react-redux';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import DateFunc from '@/lib/lyg/date_func';
import { useState, useRef, useEffect } from 'react';
import strFunc from '@/lib/lyg/string';
import { useNavigate } from 'react-router-dom';
import Style from "./css/style.module.css";
import SearchArea from "./area/search";
import ListArea from "./area/list";
import StudyDetailArea from "./area/detail_list";

function StuUseListArea(props: any) {
  let myProps = {
    show_opt: {},
    ...props
  };
  let show_opt = {
    is_show_back_btn: true,
    ...myProps.show_opt
  };
  const navigate = useNavigate();
  let user = useSelector((state: any) => state.user);
  const [page_sort, set_page_sort] = useState("list");//"list","detail"
  const [listOpt, setListOpt] = useState({
    'now_page': 1,
    'num_per_page': 10,
    'order_id': 'a_re_start_date DESC',
    'order_type': '',
    's_date_type': '',
    's_start_date': '',
    's_end_date': '',
    "s_stu_mcomp_seq": "",
    "s_stu_seq": "",
    "s_use_sort": "coolen",
    "s_addon_use_det": "1",
    s_addon_textbook: "1",
    s_addon_section: "1",
    s_addon_study: "1",
    s_addon_study_word: "1",
    "s_in_now_period": "1",
  });
  const [study_use_arr, set_study_use_arr] = useState([]);
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [select_study_use, set_select_study_use] = useState(null);
  useEffect(() => {
    list({});
  }, [user.user_seq]);
  const list = (inOptObj: any) => {
    let change_list_opt = {
      ...listOpt,
      ...inOptObj
    };

    if (strFunc.is_empty(user.user_seq)) {
      return false;
    }
    change_list_opt["s_stu_mcomp_seq"] = user.comp_seq;
    change_list_opt["s_stu_seq"] = user.user_seq;

    setListOpt(change_list_opt);
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/use/list', change_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_study_use_arr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
        } else {

        }
      });
  };

  return (
    <div>
      <div className={Style.title_wrap}>
        {show_opt.is_show_back_btn &&
          <button className='btn btn-gray'
            style={{ position: "absolute", left: 0, top: 10 }}
            onClick={() => {
              navigate("/comp_stu/coolen/move");
            }}>뒤로</button>
        }
        학습리스트
      </div>
      <div style={{ width: "90%", margin: "0 auto" }}>
        <SearchArea
          listOpt={listOpt}
          setListOpt={setListOpt}
          list={list}
        ></SearchArea>
      </div>
      {(page_sort == "detail" && select_study_use != null) ?
        <div className={Style.detail_area}>
          <StudyDetailArea
            Style={Style}
            select_study_use={select_study_use}
            set_page_sort={set_page_sort}
          ></StudyDetailArea>
        </div>
        :
        <div className={Style.list_area}>
          <ListArea
            study_use_arr={study_use_arr}
            Style={Style}
            set_page_sort={set_page_sort}
            set_select_study_use={set_select_study_use}
          ></ListArea>
          <Paging now_page={listOpt.now_page}
            num_per_page={listOpt.num_per_page}
            total_rec={countInfo.tot}
            onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
            onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>
        </div>
      }
    </div>
  );
};
export default StuUseListArea;